export default __webpack_public_path__ + "static/4-88c1bc349ac9f7fd7d2b71094cbef1c0.jpeg";